import { render, staticRenderFns } from "./CreateReferee.vue?vue&type=template&id=36bed95f&"
import script from "./CreateReferee.vue?vue&type=script&lang=js&"
export * from "./CreateReferee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports